import { Helmet } from "react-helmet";
import { API_BASE } from "../../apiBase";
import ContactUsBlock from "../Home/components/ContactUsBlock";

function ContactUs(props) {
  return (
    <div className="container">
      <Helmet>
        <title>Nepeto - Contact Us</title>
        <link rel="canonical" href="https://www.nepeto.com/contact" />
        <meta
          name="description"
          content="Contact Nepeto for fast, responsive support. We're here to assist you anytime. Don't hesitate to reach out!"
        />
        <meta
          name="keywords"
          content="amazon fba, product sourcing, contact, contact us, amazon fba products, fba products, fba sourcing"
        />
      </Helmet>

      <div className="columns is-justify-content-center">
        <div className="column is-4  is-centered" style={{ margin: "auto" }}>
          <h1
            style={{
              fontSize: props.isMobile ? "5vh" : "3vw",
              color: "#8c3e7c",
              marginTop: props.isMobile ? "5vh" : "1vh",
              marginBottom: props.isMobile ? "2.5vh" : "5vh",
            }}
          >
            Contact Us
          </h1>
          <form
            action={API_BASE + "/email"}
            method="post"
            accept-charset="UTF-8"
            className="box p-5"
            style={{ border: "1px solid rgba(0,0,0,0.12)" }}
          >
            <label className="is-block mb-4">
              <span className="is-block mb-2">Your name</span>
              <input
                name="name"
                type="text"
                className="input"
                placeholder="Nepeto Nepeto"
              />
            </label>

            <label className="is-block mb-4">
              <span className="is-block mb-2">Email address</span>
              <input
                required
                name="email"
                type="email"
                className="input"
                placeholder="support@nepeto.com"
              />
            </label>

            <label className="is-block mb-4">
              <span className="is-block mb-2">Message</span>
              <textarea
                name="message"
                className="textarea"
                rows="3"
                placeholder="Tell us what you're thinking about..."
              ></textarea>
            </label>

            <div className="mb-4">
              <button
                type="submit"
                className="button px-4"
                style={{ backgroundColor: "#8c3e7c", color: "white" }}
              >
                Submit
              </button>
              <div
                style={{
                  textIndent: "-99999px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  position: "absolute",
                }}
                aria-hidden="true"
              >
                <input
                  type="text"
                  name="_gotcha"
                  tabindex="-1"
                  autocomplete="off"
                />
                <input
                  type="text"
                  name="what_is_it"
                  value={"contact"}
                  tabindex="-1"
                  autocomplete="off"
                />
              </div>
            </div>
          </form>
        </div>
        <div className="column is-2"></div>
        <div className="column is-6">
          <ContactUsBlock />
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
